import React from 'react';
import { observer } from 'mobx-react';
import { config, setToken } from '../config';

// Helpers
import { getCookie, isAuthenticated } from '../helpers/helpers.js'

// Dependencies
import { LaunchDarkly } from 'react-launch-darkly';

// Components
import Header from './Common/Header';
import Footer from './Common/Footer';
import Loader from './Common/Loader';
import Dialog from './Common/Dialog';
import Confirm from './Common/Confirm';

// Store
import store from '../stores/'

class AppNoNav extends React.Component {
  constructor() {
    super();
    this.updateToken = this.updateToken.bind(this);
  }

  componentWillMount() {
    const { SessionStore, HelpStore } = store;

    // Set default token
    if(SessionStore.hasSessionStorage) {
      this.setState({
        token: sessionStorage.getItem('token')
      });
    } else {
      this.setState({
        token: getCookie('token')
      });
    }

    // Retrieve user data from localStorage
    let userData = {};

    if(SessionStore.hasSessionStorage) {
      userData = sessionStorage.getItem('userData');
    } else {
      userData = getCookie('userData');
    }

    if(userData) {
      store.SessionStore.getLocalStorage(JSON.parse(userData));
    }

    // Get help documents
    if(!HelpStore.helpLoaded) {
      HelpStore.getHelp();
    }

    // Redirect if not logged in
    const _this = this;
    setTimeout(function(){
      if(!isAuthenticated()) {
        _this.props.routing.history.push('/account/sign-up');
      }
    });
  }

  componentDidMount() {

    this.updateToken(this.state.token);
  }

  componentWillUpdate(nextProps) {
    const { SessionStore } = store;
    let storedToken = null;

    if(SessionStore.hasSessionStorage) {
      storedToken = sessionStorage.getItem('token');
    } else {
      storedToken = getCookie('token');
    }

    // If the token has changed, update it
    if(this.state.token !== storedToken) {
      this.setState({
        token: storedToken
      });
      this.updateToken(storedToken);
    }

    // Set the feature in the HelpStore
    store.HelpStore.feature = nextProps.feature;
  }

  updateToken(token) {
    const { SessionStore } = store;

    setToken(token);
    SessionStore.startTokenTimer(token);
  }

  render() {
    const { SessionStore } = store;

    // Detect touch device
    const docRoot = document.querySelector('html');

    if ('ontouchstart' in document.documentElement) {
      docRoot.className += ' touch';
    }

    // Apply no-nav class to body
    if(document.body.className.indexOf('no-nav') < 0) {
      document.body.className += ' no-nav';
    }

    // Environment (used by LaunchDarkly)
    let environment = 'develop';

    if(process.env.REACT_APP_ENVIRONMENT === 'production') {
      environment = 'production'
    }

    if(process.env.REACT_APP_ENVIRONMENT === 'stage') {
      environment = 'stage'
    }

    // LaunchDarkly user config
    let ldConfig = {}

    if(SessionStore.userData) {
      ldConfig = {
        key: SessionStore.userData.proctorAccountSid,
        custom: {
          domain: window.location.hostname,
          environment: environment,
          account: SessionStore.userData.proctorAccountSid,
          user: SessionStore.userData.sid
        }
      }
    }

    return (
      <LaunchDarkly clientId={config.ldApiKey} user={ldConfig}>
        <div className="viewport">
          <Header store={store} hideNav={true} />

          {React.cloneElement(this.props.children, this.props)}

          <Footer store={store} />

          {store.SessionStore.loading &&
            <Loader store={store} />
          }

          {store.SessionStore.dialog &&
            <Dialog store={store} />
          }

          {store.SessionStore.confirm &&
            <Confirm store={store} />
          }
        </div>
      </LaunchDarkly>
    )
  }
}

export default observer(AppNoNav);



// WEBPACK FOOTER //
// ./src/app/components/AppNoNav.js